/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { featureAboutMeConfig } from '../../config/featuresSection.config';
export interface IFeatureAboutMePluginMethods extends IPluginMethodMap {
  getFeatureAboutMeSync(args?: any): any;
}

export class FeatureAboutMePlugin implements IAgentPlugin {
  readonly methods: IFeatureAboutMePluginMethods;

  constructor() {
    this.methods = {
      getFeatureAboutMeSync: this.getFeatureAboutMeSync.bind(this),
    };
  }

  getFeatureAboutMeSync(args?: any) {
    return {
      feature: featureAboutMeConfig,
    };
  }
}
